import Vue from 'vue'
import Vuex from 'vuex';
import {getCookie,setCookie,delCookie} from "@/store/cookie";


Vue.use(Vuex)

const state = {
  userinfo:null,
}

const mutations = {
  setUserInfo(state,info){
    state.userinfo = info;
		var userInfoStr = JSON.stringify(info);
    setCookie("userinfo",userInfoStr);
  },
  cleanUserInfo(state){
    state.userinfo = null;
    delCookie("userinfo");
  }
}

const getter = {
  getUserInfo:function (state) {
		var userInfo = null;
  	try {
  		var userInfoStr = unescape(getCookie("userinfo"));
			userInfo = JSON.parse(userInfoStr);
		}catch(err){

		}
  	if(userInfo!=null){
  		state.userinfo = userInfo;
		}
    return state.userinfo;
  },
}

export default new Vuex.Store({
  state: state,
  mutations: mutations,
  getters:getter
})



// WEBPACK FOOTER //
// ./src/store/index.js